

 const apptheme = {
    primaryColor: '#082f49',
    secondaryColor : '#f7f7f7',
    tertiaryColor : '#2d6e98',
    quaternaryColor : '#ec9c05',
    quintenaryColor : '#44c485',
    senaryColor : '#339263',
    septenary : '#666666'

} 

export default apptheme
